import React from 'react';
import { ArrowDown, Star } from 'lucide-react';
import { motion } from 'framer-motion';
export const Hero = () => {
  return <section className="relative pt-6 md:pt-10 pb-12 md:pb-16 px-5 overflow-hidden bg-white" data-id="element-319">
      {/* Decorative Elements */}
      <div className="absolute top-20 right-[10%] text-gold text-4xl opacity-70 pointer-events-none z-0" data-id="element-320">
        ◗
      </div>
      <div className="absolute bottom-40 left-[5%] text-green-soft text-2xl opacity-80 pointer-events-none z-0" data-id="element-321">
        ▽
      </div>

      {/* Dot Grid Pattern */}
      <div className="absolute bottom-20 right-[5%] opacity-40 pointer-events-none z-0" data-id="element-322">
        <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-323">
          <pattern id="dots" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse" data-id="element-324">
            <circle cx="2" cy="2" r="2" fill="var(--green-soft)" data-id="element-325" />
          </pattern>
          <rect width="100" height="100" fill="url(#dots)" data-id="element-326" />
        </svg>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-327">
        {/* Badge */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1,
        ease: 'easeOut'
      }} className="inline-flex items-center gap-2 bg-rose-soft text-rose-deep px-4 py-1.5 rounded-full mb-5 border border-rose/15" data-id="element-328">
          <span className="flex -space-x-1.5" data-id="element-329">
            <span className="w-5 h-5 rounded-full bg-rose ring-2 ring-rose-soft" data-id="element-330" />
            <span className="w-5 h-5 rounded-full bg-gold ring-2 ring-rose-soft" data-id="element-331" />
            <span className="w-5 h-5 rounded-full bg-green-soft ring-2 ring-rose-soft" data-id="element-332" />
          </span>
          <span className="text-[13px] font-semibold tracking-tight" data-id="element-333">
            A escolha preferida de 750+ artesãs
          </span>
        </motion.div>

        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.25,
        ease: 'easeOut'
      }} className="font-serif font-extrabold text-[clamp(26px,4.5vw,48px)] leading-[1.15] tracking-[-0.02em] text-ink mb-4" data-id="element-334">
          O app de{' '}
          <span className="text-rose italic underline decoration-2 underline-offset-[3px]" data-id="element-335">
            precificação
          </span>{' '}
          e gestão de <span className="text-gold italic" data-id="element-336">pedidos</span> pra
          confeiteiras e artesãs.
        </motion.h1>

        {/* Subheadline */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4,
        ease: 'easeOut'
      }} className="text-[16px] md:text-[18px] leading-[1.5] text-ink-soft max-w-2xl mx-auto mb-8" data-id="element-337">
          Pra você{' '}
          <strong className="text-ink font-bold" data-id="element-338">
            saber quanto lucra de verdade
          </strong>
          ,{' '}
          <strong className="text-ink font-bold" data-id="element-339">
            nunca mais esquecer uma entrega
          </strong>{' '}
          e{' '}
          <strong className="text-ink font-bold" data-id="element-340">
            parar de cobrar no chute
          </strong>
          .
        </motion.p>

        {/* Comparison Table Card */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.55,
        ease: 'easeOut'
      }} className="mx-auto max-w-3xl mb-8 text-left" style={{
        border: '1px solid #F0E3DA',
        borderRadius: '18px',
        boxShadow: '0 6px 22px rgba(227,47,110,.07)',
        overflow: 'hidden'
      }} data-id="element-341">
          {/* Header */}
          <div className="grid grid-cols-2" data-id="element-342">
            <div className="bg-[#F4EFEA] text-[#9A8E84] text-[11px] uppercase tracking-[1.5px] font-bold py-3 px-3 sm:px-4 text-center flex items-center justify-center" data-id="element-343">
              ANTES
            </div>
            <div className="bg-rose text-white text-[11px] uppercase tracking-[1.5px] font-bold py-3 px-3 sm:px-4 text-center flex items-center justify-center gap-1" data-id="element-344">
              <span data-id="element-345">✦</span> COM A AURORA
            </div>
          </div>

          {/* Rows */}
          <div className="flex flex-col" data-id="element-346">
            {[['Nunca parei pra ver quanto lucro', 'Lucro do mês na tela'], ['Preço no achômetro', 'Preço justo calculado na hora'], ['Esqueci a encomenda de novo', 'Alerta de cada entrega'], ['Insumo subiu, e agora?', 'Preço se ajusta sozinho']].map((row, i) => <div key={i} className="grid grid-cols-2" style={{
            borderBottom: '1px solid #F2E8E0'
          }} data-id="element-347">
                {/* Antes Cell */}
                <div className="bg-[#FAF7F4] text-[#8A8079] p-3 sm:p-4 flex items-start gap-[6px] sm:gap-[7px] text-[12px] min-[340px]:text-[13px] leading-[1.35]" data-id="element-348">
                  <span className="text-[#C98B8B] font-bold mt-[1px] flex-shrink-0" data-id="element-349">
                    ✕
                  </span>
                  <span data-id="element-350">{row[0]}</span>
                </div>
                {/* Depois Cell */}
                <motion.div initial={{
              opacity: 0,
              backgroundColor: '#FAF7F4'
            }} whileInView={{
              opacity: 1,
              backgroundColor: '#FFFFFF'
            }} viewport={{
              once: true,
              margin: '-50px'
            }} transition={{
              delay: 0.2 + i * 0.15,
              duration: 0.5
            }} className="text-ink font-bold p-3 sm:p-4 flex items-start gap-[6px] sm:gap-[7px] text-[12px] min-[340px]:text-[13px] leading-[1.35]" data-id="element-351">
                  <span className="text-[#059669] font-bold mt-[1px] flex-shrink-0" data-id="element-352">
                    ✓
                  </span>
                  <span data-id="element-353">{row[1]}</span>
                </motion.div>
              </div>)}
          </div>

          {/* Footer */}
          <div className="grid grid-cols-2" data-id="element-354">
            <div className="bg-[#FAF7F4] p-3 sm:p-4 flex items-center justify-center text-center" data-id="element-355">
              <span className="text-[#9A8E84] text-[10px] sm:text-[11px] uppercase tracking-[1px] font-bold" data-id="element-356">
                no chute
              </span>
            </div>
            <div className="bg-rose-soft p-3 sm:p-4 flex flex-col items-center justify-center text-center" data-id="element-357">
              <span className="text-rose italic font-bold text-[12px] sm:text-[13px]" data-id="element-358">
                "Lucrei R$ 1.840 esse mês"
              </span>
              <span className="text-ink-soft text-[10px] sm:text-[11px] mt-0.5" data-id="element-359">
                Marta, confeiteira
              </span>
            </div>
          </div>
        </motion.div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 1.05,
        ease: 'easeOut'
      }} className="flex flex-col items-center gap-4" data-id="element-360">
          <a href="#transformacao" onClick={e => {
          e.preventDefault();
          document.getElementById('transformacao')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="inline-flex items-center gap-3 bg-rose text-white pl-8 pr-2 py-3 rounded-full hover:bg-rose-deep transition-all hover:scale-105 shadow-md w-full sm:w-auto justify-center no-underline group" data-id="element-361">
            <span className="font-medium" data-id="element-362">Ver como funciona</span>
            <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center group-hover:translate-y-0.5 transition-transform" data-id="element-363">
              <ArrowDown size={18} className="text-white" data-id="element-364" />
            </div>
          </a>

          {/* Social proof line */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 1.2,
          ease: 'easeOut'
        }} className="flex items-center gap-2 text-[13px] text-ink-soft" data-id="element-365">
            <span className="flex gap-0.5" data-id="element-366">
              {[...Array(5)].map((_, i) => <Star key={i} size={14} className="fill-gold text-gold" strokeWidth={0} data-id="element-367" />)}
            </span>
            <span className="font-medium text-ink" data-id="element-368">4,9</span>
            <span aria-hidden="true" data-id="element-369">·</span>
            <span data-id="element-370">+750 artesãs já usam</span>
          </motion.div>
        </motion.div>
      </div>
    </section>;
};